import { render, staticRenderFns } from "./MvpComparison.vue?vue&type=template&id=50a21e70&scoped=true&"
import script from "./MvpComparison.vue?vue&type=script&lang=js&"
export * from "./MvpComparison.vue?vue&type=script&lang=js&"
import style0 from "./MvpComparison.vue?vue&type=style&index=0&id=50a21e70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a21e70",
  null
  
)

export default component.exports